












































































import { Vue, Component } from 'vue-property-decorator';
import editRole from '@/views/system/permission/role/unit/editRole.vue';
import roleAssignFunctionalPermissions from '@/views/system/permission/role/unit/roleAssignFunctionalPermissions.vue';
import TreeContainer from '@/components/tree/tree.vue';
import { professionServer, roleServe, menuServe } from '@/api/installServer';
import logger from 'vuex/types/logger';
import { arrayToTree } from '@/util/arrayToTree';
import RoleDeptChoice from '@/views/system/permission/role/unit/roleDeptChoice.vue';

@Component({
  components: { editRole, roleAssignFunctionalPermissions, TreeContainer, RoleDeptChoice },
})
export default class AddRole extends Vue {
  editRoleFlag = 6;
  scrollbar = true;
  basicInfoData: any = {
    name: '',
    dataScopeType: '',
    description: '',
    customDeptIdList: [],
    customSpaceIdList: [],
    menuIdList: [],
    allDeptVisible: true,
    visibleDeptIdList: [],
  };

  // 用户类型 数据
  dataScopeType: Array<any> = [
    {
      value: 'all',
      label: '全部数据 ',
    },
    {
      value: 'currentSpace',
      label: '本公司数据',
    },
    {
      value: 'currentDeptAndSubDept',
      label: '本部门数据',
    },
    {
      value: 'custom',
      label: '自定义数据',
    },
  ];

  // 表单验证规则对象
  rules: object = {
    name: [{ required: true, trigger: 'blur', message: '必填信息' }], // 角色名称
    dataScopeType: [{ required: true, trigger: 'blur', message: '必填信息' }], // 数据权限类型
  };

  mounted() {
    this.hasScrollbar();
  }

  hasScrollbar() {
    const dom: any = document.querySelector('.main_box');
    this.scrollbar = dom.scrollHeight > dom.clientHeight || dom.offsetHeight > dom.clientHeight;
  }

  created() {
    this.getTreeData();
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 获取 树状图 的数据
   * @param1 暂无
   * @returns 暂无
   */
  getTreeData() {
    // 树状图的数组
    menuServe
      .getAllSysMenu({})
      .then((res: any) => {
        if (res.code === '200') {
          // console.log('res', res) // 输出全部数据
          this.unKnownData = arrayToTree(res.data);
        }
      })
      .catch(() => {
        this.$message.error('初始化数据失败，请稍后重试！');
      });
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 判断基本信息页面下 排序号 是否为正整数的方法
   * @param1 暂无
   * @returns 暂无
   */
  isNum(rule: any, value: any, callback: any) {
    if (value == '') {
      return callback();
    }
    if (typeof value !== 'number') {
      return callback(new Error('请输入一个正整数'));
    } else {
      return callback();
    }
  }
  //树状图部分的数据
  unKnownData: Array<any> = [
    {
      menuIdList: '',
    },
  ];

  /**
   * @todo 后期需要优化的部分
   * @desc 获取 未知部分的 数据
   * @param1 暂无
   * @returns 暂无
   */
  checkData(data: any) {
    // console.log(data); // 需要保存的 idList
    const menuData = data.idList;
    console.log(menuData);
    this.basicInfoData.menuIdList = menuData;
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击按钮保存 新增角色 页面内容
   * @param1 暂无
   * @returns 暂无
   */
  saveEditRole(): void {
    (this.$refs.formRef as any).validate((valid: any) => {
      if (valid) {
        if (this.editRoleFlag === 6) {
          // 新增角色
          console.log(this.basicInfoData);
          roleServe
            .addRoleData({ ...this.basicInfoData })
            .then((res: any) => {
              // if (res.code === '200') {
              this.backRole(); // 跳转到 index 页面
              this.$message.success('新增角色成功！');
              // this.$router.go(0); // 刷新
              // }
              // console.log("新增的",res)
            })
            .catch(() => {
              this.$message.error('新增角色失败,请稍后重试!');
            });
        }
      } else {
        return false;
      }
    });
  }

  /**
   * 更新可见部门的值
   * @param data
   */
  updateVisibleDeptIdList(data: any) {
    this.basicInfoData.visibleDeptIdList = data;
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击按钮返回角色管理界面
   * @param1 暂无
   * @returns 暂无
   */
  backRole(): void {
    this.$emit('close');
  }
}
